import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/EmployeeTerminated.css";
import Oiiko from "../tools/oiikotranslogo2.png";

export default function EmployeeTerminated() {
  const navigate = useNavigate();

  return (
    <div className="emp-term-wrap">
      <div className="emp-term-card">
        <img src={Oiiko} alt="Oiiko" className="emp-term-logo" />

        <h1 className="emp-term-title">Access Disabled</h1>
        <p className="emp-term-sub">
          Your account has been marked as <b>Terminated</b>, so you can’t access
          the employee dashboard anymore.
        </p>

        <div className="emp-term-actions">
          <button
            className="emp-term-btn"
            onClick={() => navigate("/login", { replace: true })}
          >
            Return to Login
          </button>
        </div>

        <p className="emp-term-foot">
          If you believe this is a mistake, contact your employer.
        </p>
      </div>
    </div>
  );
}
